export enum Role {
  None = 'none',
  Client = 'client',
  Developer = 'developer',
  Manager = 'manager',
  Sales = 'sales',
}
